(function () {
    "use strict";

    angular
        .module("app")
        .directive("lastTypeAhead", ["PatternService", lastTypeAhead]);

    function lastTypeAhead(patternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return patternService.getLastNames(scope.brandId, searchText).then(function (response) {
                        if (response) {
                            angular.forEach(response, function (item) {
                                item.DisplayText = item.LastName + " (" + item.LastNameKey + ")";
                            });
                            return response;
                        }
                        return [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.LastNameKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "=", brandId: "="},
            template: '<input' +
                ' uib-typeahead="item.DisplayText for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();

